import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { BatchFileIdList, claimListBO, SaveBatchFileBO } from '../claims.model';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})

export class ClaimListService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  GenerateClaim837(saveBatch837: SaveBatchFileBO): Observable<any> {
    let url = "api/Claims/GenerateEDI837File";
    return this.http.post(url, saveBatch837, { observe: "response", responseType: "text" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  exportClaimsWithPaginationCsv(exportClaimsBo: SaveBatchFileBO) {
    let url = "api/ClaimMaster/exportClaimsWithPaginationCsv";
    return this.http.post(url, exportClaimsBo, { responseType: 'blob' }).subscribe((data) => {
      FileSaver.saveAs(data, "ClaimsReport.csv")
    }
    )
  }

  Deleteclaims(deleteclaim: any[]): Observable<any> {
    let url = "api/Claims/deleteClaims";
    return this.http.post(url, deleteclaim, { observe: "response", responseType: "text" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  exportClaimsCurrentCsv(exportClaimsBo: claimListBO): Observable<any> {
    let url = "api/Claims/ClaimCurrentDataExport?";
    return this.http.post(url, exportClaimsBo, { observe: "response" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  exportClaimsCsv(exportClaimsBo: claimListBO): Observable<any> {
    let url = "api/Claims/ClaimExport?";
    return this.http.post(url, exportClaimsBo, { observe: "response" }).pipe(
      map((data) => data.body),
      catchError(this.errorService.handleError)
    );
  }

  MovetoarchiveFunction(saveList: BatchFileIdList[]): Observable<number> {
    let url = "api/Claims/MovetoArchive";
    return this.http.post<number>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  RestoretoActive(saveList: BatchFileIdList[]): Observable<number> {
    let url = "api/Claims/RestoreActiveClaim";
    return this.http.post<number>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

}
